var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("如何查询配送信息？")]),_c('div',{staticClass:"content-info"},[_c('p',{staticClass:"txt1"},[_vm._v("请联系在线客服或致电"+_vm._s(_vm.$concatPhone || '4006-135-135')+"查询。")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }